<template>
  <li class="language-switcher__language language">
    <a
      :href="item.link"
      class="language__link"
      :class="{ 'is-active': langSlug === this.item.current_lang }"
      :data-continent="continent"
      :data-lang-slug="langSlug"
      @click="handleClick"
    >
      {{ item.name }}
    </a>
  </li>
</template>

<script>
import Cookies from "js-cookie";

export default {
  name: 'languageListItem',
  components: {},
  props: {
    item: Object,
    continent: String,
  },
  data() {
    return {};
  },
  computed: {
    langSlug() {
      return `${this.item.code}`;
    },
  },
  methods: {
    handleClick(e) {

      e.preventDefault();

      let itemLangSlug = e.target.getAttribute('data-lang-slug');
      let itemContinent = e.target.getAttribute('data-continent');
      let href = e.target.getAttribute('href');

      Cookies.set('vispring-location-chooser-viewed', itemContinent, {
        expires: 365,
        path: '/'
      })

      localStorage.removeItem('currentLang');
      localStorage.setItem('currentLang', itemLangSlug)

      window.location = href;

    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/setup.scss';

.language {
  &:first-child {
    margin-top: 15px;
  }
  &__link {
    position: relative;
    padding-left: 38px;
    display: flex;
    font-size: 20px;
    line-height: 3;
    letter-spacing: 0.15px;

    &:hover,
    &.is-active {
      &::after {
        transform: scale(0.6);
      }
    }

    &::before,
    &::after {
      @include pseudo();
      left: 0;
      top: 0.9em;
      width: 17px;
      height: 17px;
      border-radius: 50%;
      @include anim();
    }

    &::before {
      border: 1px solid $c-black;
    }

    &::after {
      background-color: $c-black;
      transform: scale(0);
    }
  }
}
</style>
